// Intuition site chrome behaviours: mega menu, mobile drawer, predictive search popup.
// Copied from the homepage so header/footer work site-wide. Guard prevents double-init.
if (!window.__intuitionChromeBound) {
  window.__intuitionChromeBound = true;
// Mega menu hover with bridge timer
  (function() {
    // Not keyed to a literal menu handle: the mega trigger is whichever nav item the section
    // marks, so renaming it in the Shopify menu does not break the hover binding.
    const storeItem = document.querySelector('.nav-item-mega');
    const megaPanel = document.querySelector('.mega-panel');
    if (!storeItem || !megaPanel) return;

    let closeTimer = null;
    const open = () => { clearTimeout(closeTimer); megaPanel.classList.add('is-open'); };
    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => megaPanel.classList.remove('is-open'), 120);
    };

    storeItem.addEventListener('mouseenter', open);
    storeItem.addEventListener('mouseleave', scheduleClose);
    megaPanel.addEventListener('mouseenter', open);
    megaPanel.addEventListener('mouseleave', scheduleClose);
  })();

  /* Mobile drawer */
  (function() {
    const toggle  = document.querySelector('.mobile-toggle');
    const drawer  = document.querySelector('.mobile-drawer');
    const overlay = document.querySelector('.mobile-drawer-overlay');
    const closeBtn = document.querySelector('.mobile-drawer-close');
    if (!toggle || !drawer || !overlay) return;

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  })();

  /* Search popup with predictive results */
  (function() {
    const toggle   = document.querySelector('[data-search-toggle]');
    const panel    = document.querySelector('.search-panel');
    const backdrop = document.querySelector('.search-backdrop');
    const closeBtn = document.querySelector('.search-close');
    const form     = panel && panel.querySelector('.search-form');
    const input    = document.querySelector('.search-input');
    const results  = document.querySelector('.search-results');
    if (!toggle || !panel || !backdrop || !input || !results) return;

    let debounceTimer = null;
    let currentRequest = null;

    function openSearch() {
      panel.classList.add('is-open');
      backdrop.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(() => input.focus(), 320);
    }
    function closeSearch() {
      panel.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', openSearch);
    closeBtn.addEventListener('click', closeSearch);
    backdrop.addEventListener('click', closeSearch);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closeSearch();
    });

    // Prevent form navigation — keep everything inline
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        runSearch(input.value, true);
      });
    }

    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      return '$' + (cents / 100).toFixed(2);
    }

    function renderResults(data, query) {
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!query.trim()) { results.innerHTML = ''; return; }
      if (products.length === 0) {
        results.innerHTML = '<div class="search-results-empty">No results found for "' + escapeHtml(query) + '"</div>';
        return;
      }
      let html = '<div class="search-results-section">';
      html += '<div class="search-results-title">Products</div>';
      products.slice(0, 8).forEach(p => {
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        const price = p.price ? '$' + p.price : (p.compare_at_price_min ? formatMoney(p.compare_at_price_min) : '');
        html += '<a class="search-result-item" href="' + p.url + '">'
              + (img ? '<img class="search-result-thumb" src="' + img + '" alt="" loading="lazy">' : '<div class="search-result-thumb"></div>')
              + '<div class="search-result-info">'
              + '<p class="search-result-name">' + escapeHtml(p.title) + '</p>'
              + (price ? '<div class="search-result-price">' + price + '</div>' : '')
              + '</div></a>';
      });
      html += '</div>';
      html += '<a class="search-results-viewall" href="/search?q=' + encodeURIComponent(query) + '">View all results &rarr;</a>';
      results.innerHTML = html;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    }

    function runSearch(query, immediate) {
      query = (query || '').trim();
      if (!query) { results.innerHTML = ''; return; }
      if (currentRequest && currentRequest.abort) currentRequest.abort();
      const url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      if (immediate) results.innerHTML = '<div class="search-results-loading">Searching…</div>';
      const controller = new AbortController();
      currentRequest = controller;
      fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' }})
        .then(r => r.json())
        .then(data => renderResults(data, query))
        .catch(err => {
          if (err.name !== 'AbortError') {
            results.innerHTML = '<div class="search-results-empty">Search unavailable. Try again.</div>';
          }
        });
    }

    input.addEventListener('input', (e) => {
      clearTimeout(debounceTimer);
      const v = e.target.value;
      if (!v.trim()) { results.innerHTML = ''; return; }
      debounceTimer = setTimeout(() => runSearch(v, false), 220);
    });
  })();
}
